import type { MarketingRouterVariant } from '@luxuryescapes/contract-svc-promo/marketing-router/admin';

export type MarketingRouterRuleVariant = MarketingRouterVariant;

export type MarketingRouterRuleSignificanceMetric = 'ttv' | 'margin' | 'conversion';

export type MarketingRouterRule = {
  id: string;
  name: string;
  significance_metrics: Array<MarketingRouterRuleSignificanceMetric>;
  start_date: string;
  end_date: string;
  match: {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    utm_term?: string;
    utm_content?: string;
    url?: string;
  };
  variants: Array<MarketingRouterRuleVariant>;
};

export function getMarketingRouterRuleCookieName(ruleId: string, variantId: string): string {
  return `${ruleId}_${variantId}`;
}
